<div class="nanda-sheet-component" fxLayout="column">
    <app-nanda-chat
        style="height: 100%"
        [report]="data.report"
        [bordeless]="true"
        (onClose)="onCloseBottomSheet()"
    ></app-nanda-chat>
</div>
